import { featureFlagClient } from '@trello/feature-flag-client';

let isEnabled: boolean | undefined;

export const isBoardCanvasModernizationEnabled = (): boolean => {
  if (isEnabled === undefined) {
    isEnabled = featureFlagClient.get(
      'workflowers.board-canvas-modernization',
      false,
    );
  }

  return isEnabled;
};
